/* eslint-disable no-const-assign */
<template>
  <v-container fluid>
    <v-flex xs12 class="text-center justify-center mb-4 mt-6">
      <h4 class="font-weight-bold">LISTA DE USUARIOS</h4>
    </v-flex>
    <v-card>
      <v-card-text>
        <filtros
          ref="criterios"
          :campos.sync="camposfiltros"
          @actualizarFiltro="buscarCuando"
          @nuevo="addUpdate"
        ></filtros>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      class="elevation-1"
      :dense="true"
      no-data-text="Datos no disponibles"
      no-results-text="Cargando..."
      fixed-header
      :height="500"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 50, 100, 500],
      }"
      :disable-sort="true"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-spacer></v-spacer>
          <v-btn
            small
            dark
            outlined
            color="primary"
            class="mr-2"
            title="Agregar"
            @click="addUpdate"
          >
            <v-icon>mdi-plus</v-icon>Nuevo
          </v-btn> -->
        </v-toolbar>
      </template>
      <template v-slot:[`item.estado`]="{ item }">
        <v-chip
          small
          :color="item.estado ? 'success' : 'secondary'"
          dark
          v-text="item.estado ? 'Activo' : 'Inactivo'"
        >
        </v-chip>
      </template>
      <template v-slot:[`item.ciudad`]="{ item }">
        <v-btn
          v-if="item.cargo == 'Abogado' || item.cargo == 'Investigador'"
          small
          text
          @click="asignar(item)"
          color="primary"
          title="Asignar ciudad"
        >
          <v-icon left small>mdi-home-modern</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-icon small class="mr-4" title="Editar" @click="addUpdate(item)">
          mdi-pencil
        </v-icon>
        <v-icon small @click="inavilitar(item)" title="Inactivar">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <modal-add
      v-if="showModal"
      :showModal.sync="showModal"
      :id="id"
      :consulta="consulta"
      :condicion="condicion"
      @actualizar="getData"
    ></modal-add>
    <modal-ciudad
      v-if="showModalCiudad"
      :showModal.sync="showModalCiudad"
      :id="id"
      @actualizar="getData"
    ></modal-ciudad>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../../firebase";
import moment from "moment";
import Paginado from "../../helpers/Paginado";
import Filtros from "../General/Filtros.vue";
import ModalAdd from "./ModalAdd.vue";
import ModalCiudad from "./ModalCiudad.vue";

export default {
  components: {
    Filtros,
    ModalAdd,
    ModalCiudad,
  },
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Usuarios",
  data() {
    return {
      coleccion: "usuarios",
      consulta: ["Todo"],
      condicion: "in",
      campo: "cargo",
      totalItems: 0,
      lastVisible: "",
      itemsPerPage: 0,
      ordenar: "",
      typoOrdenar: false,
      page: 0,
      options: {},
      camposfiltros: [],
      campoFiltro: "",
      operadorFiltro: "",
      valorFiltro: "",
      criterios: [],
      search: "",
      loading: true,
      desserts: [],
      showModal: false,
      id: "",
      headers: [
        {
          text: "NOMBRES",
          filterable: true,
          align: "start",
          sortable: true,
          value: "nombres",
        },
        { text: "APELLIDOS", value: "apellidos" },
        { text: "IDENTIFICACIÓN", value: "identificacion" },
        { text: "EMAIL", value: "email" },
        { text: "CARGO", value: "cargo" },
        { text: "AREA", value: "area" },
        { text: "CREADO", value: "creado" },
        { text: "TELÉFONO", value: "telefono" },
        { text: "CIUDAD", value: "ciudad" },
        { text: "ESTADO", value: "estado" },
        { text: "ACCIONES", value: "action" },
      ],
      showModalCiudad: false,
      condicionDatos: {},
    };
  },
  computed: {
    ...mapState(["logueado"]),
    user() {
      return this.$store.getters.user;
    },
  },
  async mounted() {
    this.headers.forEach((element) => {
      if (
        element.value !== "estado" &&
        element.value !== "action" &&
        element.value !== "ciudad" &&
        element.value !== "creado"
      ) {
        this.camposfiltros.push({
          campo: element.value,
          etiqueta: element.text,
        });
      }
    });
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  created() {
    if (
      this.logueado.cargo == "Administrador" ||
      this.logueado.cargo == "Coordinador Contact Center" ||
      this.logueado.cargo == "Call Center"
    ) {
      this.consulta = ["Todo"];
      this.condicion = "not-in";
    }
    if (this.logueado.cargo == "Coordinador Investigador") {
      this.consulta = ["Investigador", "Dibujante"];
    }
    if (this.logueado.cargo == "Coordinador Abogado") {
      this.consulta = ["Abogado"];
    }
    if (this.logueado.cargo == "Coordinador Abogado CAIT") {
      this.consulta = ["Abogado CAIT"];
    }
    if (this.logueado.cargo == "Coordinador Perito") {
      this.consulta = ["Perito"];
    }
  },
  methods: {
    async getData() {
      try {
        const { itemsPerPage, page, sortDesc } = this.options;
        this.itemsPerPage = itemsPerPage;
        this.page = page;
        if (this.valorFiltro) {
          this.buscarCuando();
          return;
        }
        this.typoOrdenar = sortDesc[0] ? "asc" : "desc";
        this.condicionDatos = {
          campo: this.campo,
          operador: this.condicion,
          valor: this.consulta,
        };
        const paginado = new Paginado(
          db,
          this.coleccion,
          this.campo,
          this.itemsPerPage,
          this.page,
          this.condicionDatos
        );
        const { registros, total } = await paginado.data();
        this.desserts = registros;
        this.totalItems = total;
        this.loading = false;
      } catch (err) {
        this.handleError(err);
      }
    },
    async buscarCuando() {
      try {
        this.criterios = await this.$refs.criterios.enviarCriterios();
        if (this.criterios.length > 0 && this.criterios[0].valor) {
          this.criterios.forEach((element) => {
            if (element.campo && element.valor) {
              this.campoFiltro = element.campo;
              this.operadorFiltro = element.operador;
              this.valorFiltro =
                element.campo == "email" || element.campo == "cargo"
                  ? element.valor
                  : element.valor.toUpperCase().trim();
            }
          });
        }
        db.collection(this.coleccion)
          .where(this.campoFiltro, this.operadorFiltro, this.valorFiltro)
          .where(this.campo, this.condicion, this.consulta)
          .limit(this.itemsPerPage * this.page)
          .get()
          .then((resul) => {
            this.lastVisible = resul.docs[resul.docs.length - 1] || null;
            this.firstVisible = resul.docs[0] || null;
            const res = resul.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
              creado: moment(doc.data().creado).format("YYYY-MM-DD HH:mm:ss"),
            }));
            this.desserts = res;
          });
      } catch (error) {
        this.handleError(error);
      }
    },
    addUpdate(item = "") {
      if (this.condicion == "in") {
        this.$swal({
          icon: "info",
          title: "Oops...",
          text: "Usuario no autorizado",
        });
        return;
      }
      this.id = item.id;
      this.showModal = true;
    },
    asignar(item) {
      this.id = item.id;
      this.showModalCiudad = true;
    },
    inavilitar(item) {
      this.$swal({
        title: "",
        text: "Esta seguro de eliminar este registro?",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si, Eliminar !!",
      }).then((result) => {
        if (result.value) {
          db.collection(this.coleccion).doc(item.id).update({ estado: false });
          this.getData();
          // const index = this.desserts.map((el) => el.id).indexOf(item);
          // this.desserts.splice(index, 1);
        }
      });
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style src="./Usuarios.scss" lang="scss" scope></style>
